<template>
  <v-container>
    <v-dialog v-model="openFlag" persistent max-width="600px">
      <c-card class="white" :title="onDialogTitle">
        <div class="mt-2">
          <span class="red--text">*</span> 는 필수입력항목입니다.
        </div>
        <v-form lazy-validation ref="form">
          <v-container>
            <v-row align="center">
              <v-col cols="6">
                <v-row>
                  <v-col cols="12">
                    <span class="ml-1 mb-2">이름</span><span class="red--text"> * </span>
                    <v-text-field v-model="name" placeholder="이름을 입력해주세요" solo dense required :rules="[v => !!v]"
                                  hide-details :autofocus="true" color="navy" maxlength="32"></v-text-field>

                    <v-divider class="mt-3"></v-divider>
                  </v-col>

                  <v-col cols="12">
                    <span class="ml-1 mb-2">성별</span>
                    <v-radio-group v-model="gender" row>
                      <v-radio label="남자" value="M"></v-radio>
                      <v-radio label="여자" value="F"></v-radio>
                    </v-radio-group>

                    <v-divider></v-divider>
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="6">
                <c-card outlined>
                  <v-row justify="center" align="center">
                    <v-img v-if="photo" :src="photo" aspect-ratio="1"></v-img>
                    <div v-else>
                      <v-icon size="100">person</v-icon>
                    </div>
                  </v-row>
                  <v-row justify="center" align="center" class="mt-3">
                    <c-btn color="grey" outlined @click="onPickFile">사진추가</c-btn>
                    <input
                      type="file"
                      style="display: none"
                      ref="fileInput"
                      accept="image/*"
                      @change="onFilePicked"
                    />
                  </v-row>
                </c-card>

              </v-col>


              <v-col cols="12">
                <span class="ml-1 mb-2">생년월일</span><span class="red--text"> * </span>
                <v-row justify="space-around">
                  <v-select
                    class="birth-select"
                    dense
                    v-model="birthYear"
                    :items="selectYears"
                    solo
                    menu-props="{ offsetY: true}"
                    hide-details
                    required
                    :rules="[v => !!v]"
                    label="년도"
                    color="navy"
                  ></v-select>

                  <v-select
                    class="birth-select"
                    dense
                    v-model="birthMonth"
                    :items="selectMonths"
                    solo
                    menu-props="{ offsetY: true}"
                    hide-details
                    required
                    :rules="[v => !!v]"
                    label="월"
                    color="navy"
                  ></v-select>

                  <v-select
                    class="birth-select"
                    dense
                    style="width:50px"
                    v-model="birthDay"
                    :items="selectDays"
                    solo
                    menu-props="{ offsetY: true}"
                    hide-details
                    required
                    :rules="[v => !!v]"
                    label="일"
                    color="navy"
                  ></v-select>
                </v-row>

                <v-divider class="mt-3"></v-divider>
              </v-col>

              <v-col cols="12">

                <span class="ml-1 mb-2">주소</span><span class="red--text"> * </span>
                <v-text-field v-model="address" placeholder="주소를 입력해주세요" solo required :rules="[v => !!v]" hide-details
                              :autofocus="true" color="navy" maxlength="128"></v-text-field>

                <v-divider class="mt-3"></v-divider>
              </v-col>

              <v-col cols="12">
                <span class="ml-1 mb-2">연락처</span><span class="red--text"> * </span>
                <v-row align="center">
                  <v-col cols="9" class="my-0 py-0">
                    <v-row justify="space-around" align="center">
                      <v-col cols="3" class="mr-0 pr-0">
                        <v-text-field
                          v-model="mobileNo1"
                          solo
                          hide-details
                          required
                          :rules="[v => !!v]"
                          dense
                          :autofocus="true"
                          v-mask="['##', '###']"
                          color="navy"></v-text-field>
                      </v-col>
                      <v-col cols="1" class="px-0 mx-0 text-center font-weight-bold"><span>-</span></v-col>
                      <v-col cols="3" class="mx-0 px-0">
                        <v-text-field
                          id="mobileNo2D"
                          v-model="mobileNo2"
                          solo
                          hide-details
                          required
                          :rules="[v => !!v]"
                          dense
                          :autofocus="true"
                          v-mask="['###', '####']"
                          color="navy"></v-text-field>
                      </v-col>
                      <v-col cols="1" class="px-0 mx-0 text-center font-weight-bold"><span>-</span></v-col>
                      <v-col cols="3" class="ml-0 pl-0">
                        <v-text-field
                          id="mobileNo3D"
                          v-model="mobileNo3"
                          solo
                          hide-details
                          required
                          :rules="[v => !!v]"
                          dense
                          :autofocus="true"
                          v-mask="['####']"
                          color="navy"></v-text-field>
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col cols="3" class="my-0 py-0">
                    <c-btn color="blue" outlined @click="reqMobileDupl" :disabled="mobileNoBtnFlag">중복검사</c-btn>
                  </v-col>
                </v-row>

                <v-divider class="mt-3"></v-divider>
              </v-col>

              <v-col cols="12">
                <span class="ml-1 mb-2">운전자 등록번호</span><span class="red--text"> * </span>
                <c-driver-register-number
                  :license-no.sync="licenseNo"
                  :license-no-flag.sync="licenseNoFlag"
                />
                <v-divider class="mt-3"></v-divider>
              </v-col>

            </v-row>
            <v-row justify="center">
              <c-btn v-if="driverFormData" class="mr-1 mt-2" color="blue" outlined @click="onUpdateDriver">수정</c-btn>
              <c-btn v-else class="mr-1 mt-2" color="blue" outlined @click="onAddDriver">등록</c-btn>
              <c-btn class="mt-2" color="gray" outlined @click="openFlag = false">취소</c-btn>
            </v-row>
          </v-container>
        </v-form>

      </c-card>
    </v-dialog>
  </v-container>
</template>
<script>
  import { mask } from 'vue-the-mask';
  import CDriverRegisterNumber from "../../../components/CDriverRegisterNumber";

  export default {
    components: {CDriverRegisterNumber},
    directives: { mask },
    props: {
      open: {
        type: Boolean,
        default: false
      },
      driverFormData: {
        type: Object,
        default: undefined
      }
    },
    data: () => ({
      openFlag: false,

      // driverInfo
      name: '',
      gender: 'M',
      mobileNo: '',
      licenseNo: '',
      address: '',
      photoImg: null,
      photo: null,
      birthYear: '',
      birthMonth: '',
      birthDay: '',
      deviceId: '',

      selectYears: [],
      selectMonths: [],
      selectDays: [],

      mobileNo1: '',
      mobileNo2: '',
      mobileNo3: '',
      mobileNoFlag: false,
      licenseNoFlag: false,
      mobileNoRegx: /^(01[16789]|02|0[3-9][0-9])-[0-9]{3,4}-[0-9]{4}$/,
      mobileNoRegx010: /^(010)-[0-9]{4}-[0-9]{4}$/,
    }),
    watch: {
      open(value) {
        this.initData();
        if(value && this.driverFormData) {
          this.name = this.driverFormData.name;
          this.gender = this.driverFormData.gender;
          // this.mobileNo = this.driverFormData.mobileNo;
          this.mobileNo1 = this.driverFormData.mobileNo.split('-')[0];
          this.mobileNo2 = this.driverFormData.mobileNo.split('-')[1];
          this.mobileNo3 = this.driverFormData.mobileNo.split('-')[2];
          this.licenseNo = this.driverFormData.licenseNo;
          this.address = this.driverFormData.address;
          this.photo = this.$func.getImgUrl(this.driverFormData.photo);

          const birthArr = this.driverFormData.birth.split('-');
          this.birthYear = parseInt(birthArr[0]);
          this.birthMonth = birthArr[1];
          this.birthDay = birthArr[2];

          this.deviceId = this.driverFormData.deviceId;
        }
        this.openFlag = value;
      },
      openFlag(value) {
        this.$emit('update:open', value);
      },
      birthYear(value) {
        if(this.birthMonth) {
          this.selectDays = this.getDaysOfMonth(value, this.birthMonth);
        }
      },
      birthMonth(value) {
        if(this.birthYear) {
          this.selectDays = this.getDaysOfMonth(this.birthYear, value);
        }
      },
      mobileNo1(value) {
        if(!this.driverFormData) {
          this.mobileNoFlag = false;
        }
        if(value === '02' || value.length === 3) {
          document.getElementById("mobileNo2D").focus()
        }
      },
      mobileNo2(value) {
        if(!this.driverFormData) {
          this.mobileNoFlag = false;
        }
        if(value.length === 4) {
          document.getElementById("mobileNo3D").focus()
        }
      },
      mobileNo3(value) {
        if(!this.driverFormData) {
          this.mobileNoFlag = false;
        }
      },
      licenseNo(value) {
        if(!this.driverFormData) {
          this.licenseNoFlag = false;
        }
      },
    },
    computed: {
      getBtnName() {
        return this.driverFormData ? '수정' : '등록';
      },
      getImgUrl() {

      },
      onDialogTitle() {
        return this.driverFormData ? '기사 정보 수정' : '기사 등록';
      },
      mobileNoBtnFlag() {
        if(this.driverFormData !== undefined){
          this.mobileNo = this.mobileNo1+'-'+this.mobileNo2+'-'+this.mobileNo3;
          if(this.driverFormData.mobileNo === this.mobileNo){
            this.mobileNoFlag = true;
            return true;
          } else {
            this.mobileNoFlag = false;
            return false;
          }
        }
      },
    },
    methods: {
      initData() {
        this.name = '';
        this.gender = 'M';
        this.mobileNo = '';
        this.licenseNo = '';
        this.address = '';
        this.photoImg = null;
        this.photo = null;

        this.mobileNo1 = '';
        this.mobileNo2 = '';
        this.mobileNo3 = '';
        // 1960-01-01 초기값 setting
        this.birthYear = 1960;
        this.birthMonth = '01';
        this.birthDay = '01';
      },
      onAddDriver() {
        if (!(this.$refs.form.validate())) {
          this.$store.commit('snackbar', {timeout : 2000 ,msg: '비어있는 필드가 있습니다.'});
          return;
        }

        this.mobileNo = this.mobileNo1+'-'+this.mobileNo2+'-'+this.mobileNo3;
        if(!this.mobileRegxCheck(this.mobileNo)) {
          this.$store.commit('snackbar', {timeout : 2000 ,msg: '연락처 양식이 올바르지 않습니다.'});
          return;
        }

        if(this.mobileNoFlag === false) {
          this.$store.commit('snackbar', {timeout : 2000 ,msg: '연락처 중복검사를 해주세요.'});
          return;
        }

        if(this.licenseNoFlag === false) {
          this.$store.commit('snackbar', {timeout : 2000 ,msg: '운전자 등록번호 중복검사를 해주세요.'});
          return;
        }

        if(this.licenseNo.length < 15) {
          this.$store.commit('snackbar', {timeout : 2000 ,msg: '운전자 등록번호 양식이 올바르지 않습니다.'});
          return;
        }
        
        const formData = new FormData();
        formData.append('name', this.name);
        formData.append('gender', this.gender);
        formData.append('mobileNo', this.mobileNo);
        formData.append('address', this.address);
        formData.append('birth', this.birthYear + '-' + this.birthMonth + '-' + this.birthDay);
        formData.append('licenseNo', this.licenseNo);

        if(this.photoImg)
          formData.append('photo', this.photoImg);

        this.$emit('reqAddDriver', formData);

      },
      onUpdateDriver() {
        if (!(this.$refs.form.validate())) {
          this.$store.commit('snackbar', {timeout : 2000 ,msg: '비어있는 필드가 있습니다.'});
          return;
        }

        this.mobileNo = this.mobileNo1+'-'+this.mobileNo2+'-'+this.mobileNo3;
        if(!this.mobileRegxCheck(this.mobileNo)) {
          this.$store.commit('snackbar', {timeout : 2000 ,msg: '연락처 양식이 올바르지 않습니다.'});
          return;
        }

        if(this.mobileNoFlag === false) {
          this.$store.commit('snackbar', {timeout : 2000 ,msg: '연락처 중복검사를 해주세요.'});
          return;
        }

        if(this.licenseNoFlag === false) {
          this.$store.commit('snackbar', {timeout : 2000 ,msg: '운전자 등록번호 중복검사를 해주세요.'});
          return;
        }

        const formData = new FormData();
        formData.append('id', this.driverFormData.id);
        formData.append('name', this.name);
        formData.append('gender', this.gender);
        formData.append('mobileNo', this.mobileNo);
        formData.append('address', this.address);
        formData.append('birth', this.birthYear + '-' + this.birthMonth + '-' + this.birthDay);
        formData.append('licenseNo', this.licenseNo);
        formData.append('deviceId', this.driverFormData.deviceId ? this.driverFormData.deviceId.id : "");

        if(this.photoImg)
          formData.append('photo', this.photoImg);
          
        this.$emit('reqUpdateDriver', formData);

      },
      onPickFile() {
        this.$refs.fileInput.click();
      },
      onFilePicked(event) {
        const files = event.target.files;
        let filename = files[0].name;
        if (filename.lastIndexOf('.') <= 0) {
          this.$store.commit('snackbar', {timeout : 2000 ,msg: '지원하는 형식이 아닙니다.'});
          return
        } else if (files[0].size > 1000000) { // 10MB
          this.$store.commit('snackbar', {timeout : 2000 ,msg: '업로드 가능한 용량을 초과하였습니다.'});
          return
        }

        const fileReader = new FileReader();
        fileReader.addEventListener('load', () => {
          this.photo = fileReader.result;
        });
        fileReader.readAsDataURL(files[0]);
        this.photoImg = files[0];
      },
      getDaysOfMonth(year, month) {
        let days = [];
        const cntOfDays = 32 - new Date(year, month-1, 32).getDate();
        for(let i=1; i<=cntOfDays; i++) {
          if(i < 10) i = '0'+i;
          else i = i+'';
          days.push(i);
        }
        return days;
      },
      async reqMobileDupl() {
        try {

          if(!this.mobileNo1 || !this.mobileNo2 || !this.mobileNo3) {
            this.$store.commit('snackbar', {timeout : 2000, msg : '연락처를 입력해주세요.'});
            return;
          }
          this.mobileNo = this.mobileNo1+'-'+this.mobileNo2+'-'+this.mobileNo3;
          const response = await this.$api.checkDriverMobileNo(this.mobileNo);
          if(response.data === "") {
            this.mobileNoFlag = true;
            this.$store.commit('snackbar', {timeout : 2000 ,msg : '등록 가능한 번호입니다.', color:'blue'});
          } else {
            this.$store.commit('snackbar', {timeout : 2000 ,msg : '이미 등록된 번호입니다.'});
            this.mobileNo = ''
          }
        }catch (err) {
          this.$store.commit('snackbar', {err, where:'reqMobileDupl'});
        }
      },

      mobileRegxCheck(number) {
        if(number === '') return true;
        if(this.mobileNo1 === '010') return this.mobileNoRegx010.test(number)
        else return this.mobileNoRegx.test(number)
      },

    },
    mounted() {
      let years = [];
      let months = [];

      let thisYear = new Date().getFullYear();
      for(let i = thisYear - 100; i <= thisYear; i++) {
        years.push(i);
      }
      for(let i=1; i<13; i++) {
        if(i<10) i = '0'+i;
        else i=i+'';
        months.push(i);
      }

      this.selectYears = years;
      this.selectMonths = months;

    }

  }
</script>
<style>
.birth-select {
  width: 50px !important;
  margin: 0 10px !important;
}
</style>